import { Scroll } from 'App.styles'
import styled from 'styled-components'

export const Wrapper = styled.div`
  max-height: 30rem;
  ${Scroll}
`
